import type { AttachmentType } from '@/entities/consignments';

import type { ConfirmArrivalQuantityField, ConfirmArrivalUnitMode } from './types';

/** Column order of the three condition buckets, shared by the header and the rows. */
export const CONFIRM_ARRIVAL_QUANTITY_FIELDS: ConfirmArrivalQuantityField[] = ['goodQty', 'damagedQty', 'lostQty'];

/** Tabs of the modal. `transport` is a placeholder — see the placeholder component. */
export const CONFIRM_ARRIVAL_TAB = {
  ITEMS: 'items',
  TRANSPORT: 'transport'
} as const;

export type ConfirmArrivalTab = (typeof CONFIRM_ARRIVAL_TAB)[keyof typeof CONFIRM_ARRIVAL_TAB];

export const CONFIRM_ARRIVAL_UNIT_MODE: Record<Uppercase<ConfirmArrivalUnitMode>, ConfirmArrivalUnitMode> = {
  INVENTORY: 'inventory',
  HANDLING: 'handling'
};

/** Backend caps every free-text field of the body at 255 characters. */
export const CONFIRM_ARRIVAL_TEXT_MAX_LENGTH = 255;

/** Files one receipt (or release) may carry — legacy `multifileupload` allows five. */
export const CONFIRM_ARRIVAL_MAX_FILES = 5;

/** Form id — lets the footer's submit button live outside the `<form>`. */
export const CONFIRM_ARRIVAL_FORM_ID = 'receive-confirm-arrival-form';

/**
 * Type a freshly picked file starts with. `OT` (Other) is what the backend
 * assumes for a file whose type is not given, so starting there classifies
 * nothing on the operator's behalf.
 */
export const CONFIRM_ARRIVAL_DEFAULT_ATTACHMENT_TYPE: AttachmentType = 'OT';

/**
 * Sub-reasons carried in the message of a `409 STATUS_CONFLICT`. Only
 * `QUANTITY_CHANGED` is actionable by re-reading the context; the other two are
 * states the operator cannot resolve from this modal.
 */
export const CONFIRM_ARRIVAL_CONFLICT_REASON = {
  QUANTITY_CHANGED: 'QUANTITY_CHANGED',
  LOCATION_LOCKED: 'LOCATION_LOCKED',
  PRECEDES_INVENTORY_COUNT: 'PRECEDES_INVENTORY_COUNT'
} as const;
